module.exports = __webpack_public_path__ + "static/media/asterisk-sdl-green.05a0fbca.svg";